import Vue from 'vue'

import Icon from './Icon'
import Spinner from './Spinner'
import Embed from './Embed'

import InputDateTime from './InputDateTime'
import MessageBox from './MessageBox'

import Divider from './Divider'

Vue.component('XIcon', Icon)
Vue.component('XSpinner', Spinner)
Vue.component('XEmbedBase', Embed)

Vue.component('XDivider', Divider)

Vue.component('XInputDateTime', InputDateTime)
Vue.component('XMessageBox', MessageBox)
